import { useEffect, useState } from 'react';

import { AgGridReact } from 'ag-grid-react';
import { FunnelX } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import { Button } from '@/components/ui/button';
import { DonorSchedule } from '@/rtk-query.gql';

type ClearFiltersButtonProps = {
  gridRef: React.RefObject<AgGridReact<DonorSchedule>>;
  hasExternalFilters: boolean;
  onClick: () => void;
};

export const ClearFiltersButton = ({
  gridRef,
  hasExternalFilters,
  onClick,
}: ClearFiltersButtonProps) => {
  const { t } = useTranslation();
  const [hasGridFilters, setHasGridFilters] = useState(false);
  const label = t('common.clearFilters');

  // eslint-disable-next-line react-hooks/refs
  const api = gridRef.current?.api;
  useEffect(() => {
    if (!api) return;

    const onFilterChanged = () => {
      setHasGridFilters(Object.keys(api.getFilterModel()).length > 0);
    };

    onFilterChanged();
    api.addEventListener('filterChanged', onFilterChanged);

    return () => api.removeEventListener('filterChanged', onFilterChanged);
    // eslint-disable-next-line react-hooks/refs
  }, [api]);

  return (
    <Button
      type="button"
      variant="default"
      size="icon"
      className="size-[35px]"
      aria-label={label}
      title={label}
      disabled={!hasExternalFilters && !hasGridFilters}
      onClick={onClick}
    >
      <FunnelX />
    </Button>
  );
};
